import errorManager from '@/rollbar.js';

const openModals = () => {
  document.querySelector('#cure_intermedie_modal')?.addEventListener('click', (ev) => {
    eventBus.$emit('openCureIntermedieModal');
  });

  eventBus.$on('traveledKmMounted', (data) => {
    document.querySelector("[data-target='traveledKmModal']")?.addEventListener('click', (ev) => {
      eventBus.$emit('loadModalKmData');
    });
  });

  document.querySelector('.link_print_ricetta')?.addEventListener('click', (ev) => {
    eventBus.$emit('openRicettaModal');
  });

  document.querySelector('#check-equipe')?.addEventListener('click', (ev) => {
    eventBus.$emit('openAlertEquipeModal');
  });
};

const init = () => {
  try {
    openModals();
  } catch (e) {
    errorManager(e);
  }
};

window.OpenMenuModals = {
  init: init,
};
